import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  ref?: React.RefObject<HTMLDivElement>
  className?: string
  style?: React.CSSProperties
}

const AiTip = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { t } = useTranslation()
  const aiTipRef = useRef<HTMLDivElement>(null)
  useImperativeHandle(ref, () => aiTipRef.current!)
  return <div ref={aiTipRef} className={props.className} style={{ display: 'flex', color: '#999', ...props.style }}>{t('dashboard.projectDetailPage.aiTip')}</div>
})

export default AiTip